import ReviewEntity from "@apps/reviews/entities/ReviewEntity";
import {
    ActiveState,
    EntityState,
    EntityStore,
    StoreConfig,
} from "@datorama/akita";
import { singleton } from "tsyringe";

export interface ReviewsGalleryState
    extends EntityState<ReviewEntity, number>,
        ActiveState {}

function createInitialState(): ReviewsGalleryState {
    return {
        active: null,
    };
}

@singleton()
@StoreConfig({ name: "reviews_gallery_store", idKey: "uid" })
class ReviewsGalleryStore extends EntityStore<ReviewsGalleryState> {
    constructor() {
        super(createInitialState());
    }
}

export default ReviewsGalleryStore;
